import React from "react";
import PageHeader from "../components/PageHeader";
import { registrationTiers } from "../mock";
import { useReveal } from "../hooks/useReveal";

const categories = registrationTiers[0].prices.map((p) => p.label);

const Registration = () => {
  useReveal();
  return (
    <div>
      <PageHeader title="Registration" crumb="Registration" subtitle="Secure your place at DRS 2026. Early-bird rates available for a limited time." />

      <section className="section-pad bg-white">
        <div className="max-w-5xl mx-auto px-5 lg:px-8">
          <div className="overflow-hidden rounded-2xl border border-slate-200 shadow-sm">
            <div className="overflow-x-auto">
              <table className="w-full text-left">
                <thead>
                  <tr className="bg-navy-800 text-white">
                    <th className="px-6 py-4 font-display font-bold text-sm">Category</th>
                    {registrationTiers.map((tier) => (
                      <th key={tier.phase} className="px-6 py-4 text-center">
                        <div className="font-display font-bold text-sm">{tier.phase}</div>
                        <div className="text-xs font-normal text-slate-300 mt-0.5">{tier.deadline}</div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {categories.map((cat, i) => (
                    <tr key={cat} className={`border-b border-slate-100 ${i % 2 === 0 ? "bg-white" : "bg-slate-50"} hover:bg-orange-50/50 transition-colors`}>
                      <td className="px-6 py-4 font-medium text-navy-900 text-sm">{cat}</td>
                      {registrationTiers.map((tier) => (
                        <td key={tier.phase} className="px-6 py-4 text-center font-display font-bold text-navy-900">
                          {tier.prices[i].price}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <p className="mt-4 text-center text-xs text-slate-400">* PG Students & Allied HCPs require valid proof. GST applicable as per norms.</p>

          <div className="mt-10 text-center">
            <a
              href="https://rxevents.swasthyasetu.in/rxevent/drsidfcomplications"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-shine inline-flex items-center gap-2 bg-brand hover:bg-brand-600 text-white font-semibold rounded-full px-8 py-3.5 text-base shadow-lg shadow-brand/25 transition-colors"
            >
              Register Now
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Registration;
